module.exports = __webpack_public_path__ + "hot-composition.1f2a1bbd.png";